<div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
  <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px;">
    <div fxFlex>Retry Fax</div>
    <button mat-icon-button [mat-dialog-close]="false" class="button-40">
      <mat-icon>close</mat-icon>
    </button>
  </h1>

  <mat-dialog-content class="mat-typography" fxFlex>
    <div fxLayout="column" fxLayoutGap="10px">
      <form [formGroup]="form" novalidate (ngSubmit)="onRetry()">
        <app-mat-recipients-multiselect fxFlex [formControl]="contactsControl" [submitted]="submitted"
                                        [groups]="['Contacts']"
                                        label="Send To"
                                        placeholder="Search for contacts">
        </app-mat-recipients-multiselect>
      </form>

      <label class="regular-label">Fax Preview</label>
      <div class="inner-container" style="position: relative; overflow: auto; background: gray; height: 400px">
        <div style="display: inline-block; width: 100%; padding: 5px; background-color: gray; height: 100%;">
          <app-pdf-viewer [src]="previewPdf1" *ngIf="previewPdf1"
                      (afterLoadComplete)="afterPdfLoaded()"
                      class="preview-holder"
          ></app-pdf-viewer>
        </div>
        <div
          style="display: inline-block; width: 100%; padding: 5px; background-color: gray; height: 100%; margin-top: 5px;"
          *ngIf="previewPdf2">

          <app-pdf-viewer [src]="previewPdf2"
                      (afterLoadComplete)="afterPdfLoaded()"
                      class="preview-holder"
          ></app-pdf-viewer>
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button color="primary" (click)="onRetry()" [disabled]="submitted">Retry</button>
  </mat-dialog-actions>
</div>
